"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDIGGOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var BDIGGOracleFactory = /** @class */ (function (_super) {
    __extends(BDIGGOracleFactory, _super);
    function BDIGGOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    BDIGGOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BDIGGOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BDIGGOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BDIGGOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BDIGGOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return BDIGGOracleFactory;
}(contracts_1.ContractFactory));
exports.BDIGGOracleFactory = BDIGGOracleFactory;
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "DIGG",
        outputs: [
            {
                internalType: "contract BaseERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bDIGG",
        outputs: [
            {
                internalType: "contract IBadgerSett",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "btcUsdChainlinkOracle",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "btcUsdChainlinkScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "diggBtcChainlinkOracle",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "diggBtcChainlinkScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "diggScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
